module.exports = __webpack_public_path__ + "static/media/pycharm.23b320bf.svg";